import { render, staticRenderFns } from "./BuyRegisterOver.vue?vue&type=template&id=077077de&scoped=true&"
import script from "./BuyRegisterOver.vue?vue&type=script&lang=js&"
export * from "./BuyRegisterOver.vue?vue&type=script&lang=js&"
import style0 from "./BuyRegisterOver.vue?vue&type=style&index=0&id=077077de&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077077de",
  null
  
)

export default component.exports